module.exports = __webpack_public_path__ + "img/22logo-black@3x.d6d8e58e.png";